import { render, staticRenderFns } from "./TSUserElement.vue?vue&type=template&id=904c8ca6"
import script from "./TSUserElement.vue?vue&type=script&lang=js"
export * from "./TSUserElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports